import React from 'react';
import { array, string } from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import PaymentDetailsContent from '../PaymentDetailsContent';

const PaymentDetails = ({
  orderPaymentResultList,
  confirmationMsg,
}) => {
  if (orderPaymentResultList.length === 0) {
    return null;
  }
  return <div className="payment-details">
    <div className="second-level-title payment-details__title">
      <h2 className='cui-mg-b-0'><Locale id="checkout.lib.components.text.paymentDetails" /></h2>
    </div>
    {
      orderPaymentResultList.map(({
        order: { orderNumber },
        paymentResultList, agency, installments,
      }) => (
        <PaymentDetailsContent
          key={orderNumber}
          paymentResultList={paymentResultList}
          installments={installments}
          agency={agency}
          confirmationMsg={confirmationMsg}/>
      ))
    }
  </div>;
};

PaymentDetails.propTypes = {
  orderPaymentResultList: array,
  confirmationMsg: string,
};

PaymentDetails.defaultProps = {
  orderPaymentResultList: [],
};

export default PaymentDetails;
